import React, { Suspense, Component } from "react";
import {
  withRouter
} from 'react-router-dom';
import {
  Modal,
} from "@shopify/polaris";
import './index.scss'
import './page.scss'
import {
  // reqGetHomeCommonData,
  reqAddActionEventLog,
  reqGetAppAds,
  reqDelCache,
  reqSaveSwitchState,
  reqGetCouponOffer,
  reqGetNewUserPricingPlanList,
  reqGetGuideSteps,
  reqAddAdsClickNum,
  reqGetHomeInit,
  reqTrackDeepLinkOpen,


} from '../../../api';
//新人折扣弹窗
import EventInformation from '../DashboardV2/components/EventInformation/index'
import ToastFunc from "../../../components/ToastFunc";
import SkeltonLoading from "../../../components/SkeltonLoading";
import utils from '../../../utils/utils';
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { v4 as uuidv4 } from 'uuid';
// 获取全局公共数据
import { connect } from 'react-redux'
import { setPublicData, changeActShowStatus, setWindowWidth, setWindowScrollY, setAppPublicInit, setPayTipStatus, setActMealResData, setTopMenuState, setAllAdverData, setScrollHiddenState, savePayTip, setShopifyLang, changeLanguageInfo, setLangState, setSaveSwitchData, setWindowSendData, setAiGuideList, setChatwillInstalled, setHomeStreamData, setUpgradePosition } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store'

// loading
import SkeltonSpinnerLoading from '../../../components/SkeltonSpinnerLoading';
import Language from '../../../i18n/Language';

//首页
import DashboardClass from '../DashboardV2/dashboardClassNewV3';
//分数检测服务页面
import SiteSpeedup from '../SiteSpeedup/indexClass';
//404 broken link 页面
import BrokenLinkPage from '../BrokenLink/indexClass';
// 关键词规划
import KeywordContentPlanner from '../KeywordContentPlanner/index';
// 关键词规划详情
import ContentPlannerDetail from '../KeywordContentPlanner/ContentPlannerDetail/index';
// 关键词
import KeywordsData from '../Keywords/indexClass';
//价格页面
import Pricing from '../Pricing/index/Pricing';
// 设置页面
import Settings from '../Settings/indexClass';
// 图片压缩 | alt
import ImageOptimization from "../PageSpeed/indexV2/indexClass";
import ImageOptimizationSettings from "../PageSpeed/indexV2/setting/ImageSettings";
import ImageAltText from "../ImageAltText/index";

// 新手引导
import NewUserGuide from "../NewUserGuide";
import TaskReward from "../../../components/TaskReward/index";
// shopify api组件
import NavMenuList from "../../../components/NavMenuList";
import ModalAMPCustomize from "../../../components/ModalElement/ModalAMPCustomize";
import ModalOnpageAI from "../../../components/ModalElement/ModalOnpageAI";
import CongratsModal from "../../../components/CongratsModal";
import NewDiscountUpgradeModal from "../../../components/NewDiscountUpgradeModal";
// 爬取索引
import CrawlingIndexing from "../CrawlingIndexing/index";
// SEOMetadata
import SEOMetadata from "../SEOMetadata/index";

// lodash-es
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';

import UserTrialDicountModal from "../../../components/UserTrialDicountModal";
import GetMoreUsageModal from "../../../components/GetMoreUsageModal";
import ExclusiveOfferModal from "../../../components/ExclusiveOfferModal";
import { setPageData } from "../../../redux/actions/getAppPageData";
import CreateFloatingModule from "../../../components/CreateFloatingModule";
import { CWTracksProvider } from "../CWTracksProvider";
import ContentAuditDetail from "../OnPageSEO/ContentAuditDetail";
import { API_DOMAIN } from "../../../utils/constants";
import { cwreport } from '../../../cw_center/cw-report';
import { transportReport } from "../../../cw_center/global";
import { computePlanSource } from "../../../utils/planSourceCalc";
import AllPage from "../../../utils/AllPage.json";
import OverageModal from "../../../components/OverageModal";
import OverageFeeModal from "../../../components/OverageFeeModal";
import { showNewMessage } from "@intercom/messenger-js-sdk";
import { TitleBar } from "@shopify/app-bridge-react";

// ****** 设置懒加载页面
//SEO Checker 检测页面
const WebsiteCheckClass = React.lazy(() => import('../WebsiteCheck/indexClass'));
//On page 操作页面
const OnPageSEOIndexClass = React.lazy(() => import('../OnPageSEO/index/indexClassV2'));
// onpage 详情页
// const OnPageSEODetail = React.lazy(() => import('../OnPageSEO/index/components/SheetDetail/index'));
//外链互换页面
const ExchangeBacklink = React.lazy(() => import('../ExchangeBacklink/indexClass'));
const BacklinkAudit = React.lazy(() => import('../BacklinkAudit/indexClass'));
//AMP 页面
const ServiceAMPClass = React.lazy(() => import('../ServiceAMP/indexClass'));
const ServiceAMPCustome = React.lazy(() => import('../ServiceAMP/custome/indexClass'));
//google流量分析页面
const GoogleSearchConsole = React.lazy(() => import('../AdvancedSettings/GoogleSearchConsoleV2/indexClassV2'));
// 关键词搜索
const KeywordsSearch = React.lazy(() => import('../KeywordsSearch/indexClass'));
// 关键词对比
const KeywordsGap = React.lazy(() => import('../KeywordsGap/indexClass'));
// 竞争网站对比
const KeywordsMonitor = React.lazy(() => import('../KeywordsMonitor/indexClass'));
//问答页面
const Canny = React.lazy(() => import('../Canny/indexClass'));
//推荐应用页面
const Integration = React.lazy(() => import('../Integration/indexClass'));
// 及时索引
const InstantIndex = React.lazy(() => import('../InstantIndex/indexClass'));
// 旧版价格页
const OldPricing = React.lazy(() => import('../Pricing/oldversion/Pricing'));
//HTML Sitemap 页面
const HtmlSitemap = React.lazy(() => import('../HtmlStiemap/index/indexClass'));
// Json LD 页面
const StructuredData = React.lazy(() => import('../SnippetsJSONLD/index'));
// Organization 页面
const OrganizationSet = React.lazy(() => import('../SnippetsJSONLD/Organization/index'));
// Product Schema 页面
const ProductSchema = React.lazy(() => import('../SnippetsJSONLD/ProductSchema/index'));
// 批量操作页面V2
const ManualBulkEdit = React.lazy(() => import('../BulkEditTag/indexClass'));
//图片压缩页面V2
const ImageOptimizationDetail = React.lazy(() => import('../PageSpeed/indexV2/detail/indexClass'));
const ImageOptAltDetail = React.lazy(() => import('../ImageAltText/historyTable/detail/indexClass'));
//竞品关键词分析页面
const CompetitorKeywordsDetail = React.lazy(() => import('../CompetitorKeywordsDetail/indexClass'));
// 报告数据页面
const ReportData = React.lazy(() => import('../ReportData/indexClass'));
// 博客生成器
const AiBlogGenerator = React.lazy(() => import('../AiBlogGenerator/index'));
// 博客生成器进度页面
const GenerateProgress = React.lazy(() => import('../AiBlogGenerator/GenerateProgress/index'));
// 网站验证
const SiteVerification = React.lazy(() => import('../SiteVerify/indexClass'));
// llms.txt
const LlmsTxt = React.lazy(() => import('../llmsTxt/indexClass'));
// 模块组件
const NewReviewModal = React.lazy(() => import('../../../components/ReviewModal'));

const t = Language;

// pageName 对应 AllPage.json 里的页面名称
const PAGE_NAME_PATH = {
  "ReportData": AllPage["/reports"],
  "dashboard": AllPage["/dashboard"],
  "website-check": AllPage["/website-check"],
  "SiteSpeedup": AllPage["/speedOpt/site-speedup"],
  "html-sitemap": AllPage["/technicalSEO/html-sitemap"],
  "Broken-link": AllPage["/technicalSEO/broken-link/view-errors"],
  "structured-data": AllPage["/technicalSEO/structured-data"],
  "organization": AllPage["/technicalSEO/structured-data/organization"],
  "product-schema": AllPage["/technicalSEO/structured-data/product"],
  "Bulk-edit": AllPage["/on-page-seo/bulk-edit/manual-bulk-edit"],
  'BacklinkAudit': AllPage["/backlinks/backlink-audit"],
  'exchange-backlink': AllPage["/backlinks/exchange-backlink"],
  "InstantIndex": AllPage["/technicalSEO/instant-index"],
  "ImageAltText": AllPage["/on-page-seo/image-alt-text"],
  "ImageOptAltDetail": AllPage["/on-page-seo/image-alt-text/details"],
  "ImageOptimization": AllPage["/speedOpt/PageSpeed"],
  "ImageOptimizationDetail": AllPage["/speedOpt/PageSpeed/details"],
  "ImageOptimizationSettings": AllPage["/speedOpt/PageSpeed/settings"],
  "on-page-seo": AllPage["/on-page-seo/list"],
  "ContentAuditDetail": AllPage["/on-page-seo/content-edit"],
  "site-verifications": AllPage["/technicalSEO/site-verification"],
  "crawling-indexing": AllPage["/technicalSEO/crawling-indexing"],
  "llms-txt": AllPage["/technicalSEO/llms-txt"],
  "seo-metadata": AllPage["/on-page-seo/seo-metadata"],
  "Keyword-content-planner": AllPage["/content-seo/keyword-content-planner"],
  "content-planner-detail": AllPage["/content-seo/keyword-content-planner/detail"],
  "Ai-blog-generator": AllPage["/content-seo/ai-blog-generator"],
  "Ai-blog-generator-progree": AllPage["/content-seo/ai-blog-generator/generate"],
  "Keywords-data": AllPage["/keywordRearch/keywords-data"],
  "Competitor-keywords-detail": AllPage["/keywordRearch/keywords-research/Competitor-keywords-detail"],
  "KeywordsSearch": AllPage["/keywordRearch/keywords-search"],
  "KeywordsGap": AllPage["/keywordRearch/keywords-gap"],
  "KeywordsMonitor": AllPage["/keywordRearch/keywords-monitor"],
  "google-search-console": AllPage["/keywordRearch/GoogleSearchConsoleV2"],
  "seo-ant-amp": AllPage["/speedOpt/seo-ant-amp"],
  "seo-ant-amp-custome": AllPage["/speedOpt/seo-ant-amp/custome"],
  'canny': AllPage["/dashboard/Feedback"],
  "integration": AllPage["/dashboard/integration"],
  "pricing": AllPage["/plan"],
  "oldversion-pricing": AllPage["/plan"],
  "Settings": AllPage["/settings"],
  "NewUserGuide": AllPage["/guide"],
};

// 多层面包屑配置：子页 pageName -> { parentName: 父级在 PAGE_NAME_PATH 中的 key（breadcrumb 文案）, parentPath: 点击返回的路由, selfKey: 第三层只显示的标题翻译 key }
// 命中此表的页面，TitleBar 第三层只显示 selfKey，父级以 breadcrumb 按钮形式展示（App 名由 Shopify 自动补在最前）
// 父级归属以左侧导航菜单（NavigationRoute）的 matches 归属为准，而非路由层级。
// Shopify ui-title-bar 仅支持三层（App名 › 一个 breadcrumb › 当前页），更深的页面取其所属的导航菜单项作为唯一父级。
const PAGE_BREADCRUMB = {
  // 归属「Content Audit & Optimizer」菜单项
  "ContentAuditDetail": { parentName: "on-page-seo", parentPath: "/on-page-seo/list", selfKey: "Edit" },
  // 归属「SEO Metadata」菜单项（而非各自的路由上级）
  "ImageAltText": { parentName: "seo-metadata", parentPath: "/on-page-seo/seo-metadata", selfKey: "Image Alt Text" },
  "ImageOptAltDetail": { parentName: "seo-metadata", parentPath: "/on-page-seo/seo-metadata", selfKey: "Image Alt Text Details" },
  "Bulk-edit": { parentName: "seo-metadata", parentPath: "/on-page-seo/seo-metadata", selfKey: "Manual Bulk Edit" },
  // 归属「Image Optimization」菜单项
  "ImageOptimizationDetail": { parentName: "ImageOptimization", parentPath: "/speedOpt/PageSpeed", selfKey: "Details" },
  "ImageOptimizationSettings": { parentName: "ImageOptimization", parentPath: "/speedOpt/PageSpeed", selfKey: "Settings" },
  // 归属「AI Content Planner」菜单项
  "content-planner-detail": { parentName: "Keyword-content-planner", parentPath: "/content-seo/keyword-content-planner", selfKey: "Details" },
  // 归属「AI Blog Generator」菜单项
  "Ai-blog-generator-progree": { parentName: "Ai-blog-generator", parentPath: "/content-seo/ai-blog-generator", selfKey: "Generate" },
  // 归属「Structure Data」菜单项（而非各自的路由上级）
  "organization": { parentName: "structured-data", parentPath: "/technicalSEO/structured-data", selfKey: "Organization" },
  "product-schema": { parentName: "structured-data", parentPath: "/technicalSEO/structured-data", selfKey: "Product schema" },
  // 归属「Crawling & Indexing」菜单项（而非各自的路由上级）
  "html-sitemap": { parentName: "crawling-indexing", parentPath: "/technicalSEO/crawling-indexing", selfKey: "HTML Sitemap" },
  "InstantIndex": { parentName: "crawling-indexing", parentPath: "/technicalSEO/crawling-indexing", selfKey: "Instant Index" },
  "llms-txt": { parentName: "crawling-indexing", parentPath: "/technicalSEO/crawling-indexing", selfKey: "LLMs.txt" },
  // 归属「Competitor Analysis」菜单项
  "Competitor-keywords-detail": { parentName: "KeywordsMonitor", parentPath: "/keywordRearch/keywords-monitor", selfKey: "Details" },
  "KeywordsGap": { parentName: "KeywordsMonitor", parentPath: "/keywordRearch/keywords-monitor", selfKey: "Keyword Gap" },
  // 归属「AMP」菜单项
  "seo-ant-amp-custome": { parentName: "seo-ant-amp", parentPath: "/speedOpt/seo-ant-amp", selfKey: "Custom" },
};

let cacheTimer = [];
// let indexTag = 0;

class FrameClass extends Component {
  state = {
    //升级框
    proPlanshow: false,
    //高级版升级弹窗
    premiumPlanShow: false,
    //选择页面
    pageName: this.props.name,
    showClean: false,
    cleanCodeLoading: false,
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误
    app_status: 1,
    has_selected: false,
    selected_404: '',
    selected_json: '',
    selected_all: '',
    recover_404: '',
    recover_json: '',
    recover_all: '',
    clean_all_picture: '', //all 图片
    //等级
    level: 1,
    //语言
    selectedLanguage: window.language ? window.language : 'en',
    shopify_level: '',

    showCleanPrompt: false,

    //是否显示好评弹窗
    showReview: false,
    //点击打开好评弹窗
    openReview: false,
    //好评弹窗文字
    reviewContent: '',

    //弹窗评价name和邮箱
    modalName: '',
    modalEmail: '',
    modalDefaultEmail: '',
    newList: [],
    loadingShowNewsOpen: true,
    countNews: 0,
    staff: [
      'Abbey Mayert',
      'Abbi Senger',
      'Abdul Goodwin',
      'Abdullah Borer',
      'Abe Nader',
      'Abigayle Smith',
      'Abner Torphy',
      'Abraham Towne',
      'Abraham Vik',
      'Ada Fisher',
      'Adah Pouros',
      'Adam Waelchi',
      'Adan Zemlak',
      'Addie Wehner',
      'Addison Wexler',
      'Alex Hernandez',
    ],
    visibleStaffIndex: 5,
    languageActive: false,
    LanguageSelectArr: {
      'en': window.language === 'en' ? true : false,
      'fr': window.language === 'fr' ? true : false,
      'ge': window.language === 'ge' ? true : false,
      'it': window.language === 'it' ? true : false,
      'pt': window.language === 'pt' ? true : false,
      'sp': window.language === 'sp' ? true : false,
      'dut': window.language === 'dut' ? true : false,
      'in': window.language === 'in' ? true : false,
      'zh': window.language === 'zh' ? true : false
    },

    //通知功能
    messageStatus: true,
    messageSelected: 0,
    messagePage: 1,
    messageHasMore: true,
    typeTabs: [
      {
        id: 3,
        content: t("Expert service"),
        accessibilityLabel: "All customers",
        panelID: "expert-message-id"
      }, {
        id: 2,
        content: t("Paid Plan"),
        panelID: "paid-message-id"
      }, {
        id: 1,
        content: t("System"),
        panelID: "sys-message-id"
      }],

    messageTotal: {},
    messageUnreadTotal: {},
    firstGetStauts: true,
    couponExpirationString: " ",
    // 导航栏子项选中
    topNavSelectArr: {
      '/on-page-seo/bulk-edit/manual-bulk-edit': window.location.pathname === '/on-page-seo/bulk-edit/manual-bulk-edit' ? true : false,
      '/speedOpt/PageSpeed': window.location.pathname === '/speedOpt/PageSpeed' ? true : false,
      '/admin/PageSpeed/setting': window.location.pathname === '/admin/PageSpeed/setting' ? true : false,
      "/on-page-seo/list": window.location.pathname === "/on-page-seo/list" ? true : false,
      '/technicalSEO/broken-link/view-errors': window.location.pathname === '/technicalSEO/broken-link/view-errors' ? true : false,
      '/backlinks/broken-link/manage-redirects': window.location.pathname === '/backlinks/broken-link/manage-redirects' ? true : false,
      '/backlinks/broken-link/ignore-page': window.location.pathname === '/backlinks/broken-link/ignore-page' ? true : false,
      '/technicalSEO/html-sitemap': window.location.pathname === '/technicalSEO/html-sitemap' ? true : false,
      '/technicalSEO/llms-txt': window.location.pathname === '/technicalSEO/llms-txt' ? true : false,
      '/backlinks/exchange-backlink': window.location.pathname === '/backlinks/exchange-backlink' ? true : false,
      '/keywordRearch/GoogleSearchConsoleV2': window.location.pathname === '/keywordRearch/GoogleSearchConsoleV2' ? true : false,
      '/technicalSEO/structured-data': window.location.pathname === '/technicalSEO/structured-data' ? true : false,
      '/admin/Competitor-Keywords': window.location.pathname === '/admin/Competitor-Keywords' ? true : false,
      '/keywordRearch/keywords-research/Competitor-keywords-detail': window.location.pathname === '/keywordRearch/keywords-research/Competitor-keywords-detail' ? true : false,
      '/admin/Keywords-Library': window.location.pathname === '/admin/Keywords-Library' ? true : false,
      '/speedOpt/seo-ant-amp': window.location.pathname === '/speedOpt/seo-ant-amp' ? true : false,
      '/admin/function-integration': window.location.pathname === '/admin/function-integration' ? true : false,
    },

    // 顶部导航栏
    tabs: [

    ],
    topSelected: window.topNavSelected ? window.topNavSelected : 0,
    // 顶部导航栏第一个下拉
    basicActive: false,
    AdvancedActive: false,
    // 顶部导航栏url
    topUrl: '',
    //监听屏幕
    wInnerWidth: window.innerWidth,

    //新手引导遮罩状态
    noviceGuideBackdropStatus: false,
    //新手引导气泡状态
    noviceGuideBubbleStatus: true,
    //优惠券数据
    showCouponData: false,
    //除了首页和价格页 其他页面传空 新人折扣弹窗
    showType: window.location.pathname === '/dashboard' ? 'index' : (window.location.pathname === '/plan' ? 'pricing' : ''),
    //是否点击了右侧礼物盒 修改新人折扣弹窗状态
    openStatus: false,
    //是否第一次关闭 优惠弹窗 false 没有点击 true 点击
    isFirstCloseConponModal: false,
    //新手引导是否结束
    noviceGuideIsDone: false,
    //第一次请求关闭弹窗接口
    firstReqClose: false,
    // 活动展示状态
    showBlackFridayModal: -1,
    showBlackFridayBanner: -1,
    curPage: window.location.pathname,
    //弹窗组件传来的时间
    fromModalTime: "00:00:00",

    // 活动数据
    isHasActivity: false, // 是否有活动
    activityMes: {},
    actId: -1, // 活动id
    actName: '', // 活动Name

    isResetData: false, // 是否第二次以上更新

    isExpandedNav: true, // 是否展开左侧导航栏
    ishoverExpandeNav: false, // 是否触摸展开导航栏
    isShowNavIcon: false, // 是否展示菜单new||hot图标
    isHideNewbieTipModal: null, // 新手引导提示弹窗第二状态
    isShowRouteBlock: false,
    isHasActivityMeal: false, // 改版活动状态
    ActRversion: {}, // 改版活动数据
    act_expired_time: '00:00:00', // 倒计时
    act_expired_mills_time: '00', // 毫秒
    openActMealModal: false,
    isShowInfo: false,   // 是否展示
    uid: -1,
    adverInfo: {}, // 广告数据
    adverloading: true,
    isShowTask: false,
    isNewUserIncentives: false, // 是否存在任务
    switchData: {},
    quotaAll: {},
    isAddImageQuota: false, // 增加图片额度
    upgradeModalShow: false,  // 价格弹窗状态
    upgradeModalType: 'Backlink',  // 价格弹窗类型
    upgradeModalPosition: '',  // 升级位置
    isActLoading: true,
    trial_days: 0,          // 剩余试用天数
    creditsShow: false,     // 是否提示ai积分
    ppid: -1,   // 版本id
    isShowShopifyNavMenu: true,  // 内嵌侧边栏
    isCanSetModal: false,        // 是否支持打开模态框
    isHideNav: false,   // 是否隐藏侧边栏
    onpagePubilsh: true,  // 内部是否发布
    onpagePubilshLoading: false,

    // 内嵌事件对象
    embedOnpageAIData: null,
    congraState: false,   // 新手引导完成状态
    isCloseCongra: false, // 是否关闭新手引导
    isDouble: false,   // uid -- 双数true 单数false
    embedOnpageBlogData: null, // ai博客数据
    isFromPage: "",
    isShowFeedback: false,      // 任务问题列表弹层状态
    isShowSharePlat: false,     // 任务分享平台弹层状态
    isNeedTrack: true, // 是否需要上传cio

    //点击打开好评弹窗
    openReview: false,
    //好评弹窗文字
    reviewContent: '',
    //弹窗评价name和邮箱
    modalName: '',
    modalEmail: '',
    modalDefaultEmail: '',
    //试用弹窗状态
    showTrialModalState: false,
    //试用弹窗类型
    stageType: 1,
    limitType: '',
    trial_days: 0,
    showGetMoreUsageModal: false,
    showExclusiveOfferModal: false,
    isComboUser: false,  // 是否组合套餐用户
    isShowCwComboModal: false,  // cw组合套餐提示弹窗
    language: 'en',
    remainQuota: 0,
    allowPathShow: false,
    isShowAiGuide: false,
    guideStateData: [],
    domain: '',
    structureReviewApps: [],
    structureSupportedReviewApps: [],
    shopInfo: {},
    overageState: false,   // 超额状态 
    overageType: 'image',   // 超额类型 image | points
    overagePoints: 0,       // 开启超额需扣除/授权的额度
    overageFeeState: false, // 超额已达上限弹窗
  }

  UNSAFE_componentWillMount() {
    // 动态删除之前插入的样式，恢复滚动条 (在设置页的cw集合页)
    if (this.props.public.isHiddenScroll) {
      const styleTags = document.head.getElementsByTagName('style');
      for (let i = 0; i < styleTags.length; i++) {
        if (styleTags[i].innerHTML.includes('.isSetScrollHidden{}')) {
          document.head.removeChild(styleTags[i]);
        }
      }
      this.props.setScrollHidden(false);
    }

    // 监听 操作聊天icon
    this.toggleChatIcon();

    // 判断是否其中一个路由
    const allowPathLens = ["/on-page-seo", "/on-page-seo/list", "/content-seo", "/content-seo/keyword-content-planner", "/content-seo/ai-blog-generator"].filter(i => (window.location.pathname) === i).length;
    this.setState({
      allowPathShow: allowPathLens > 0,
    }, () => {
      // 获取引导步骤
      if (allowPathLens > 0) {
        this.getGuideSteps();
      }

    })
  }

  //进入页面调用接口
  componentDidMount() {
    // Sidekick 埋点
    const searchParams = new URLSearchParams(window.location.search);
    const platform = searchParams.get('platform');
    const source_event_id = searchParams.get('source_event_id');
    if (platform === 'sidekick' && source_event_id) {
      this.sidekickTrackDataSet({
        source_event_id,
        landing_page: `app:/${(window.location.href).replace(/^https?:\/\/[^/]+/, "")}`
      });
    }

    // 增加内嵌模式判断 - 翻译
    const isShopify = window.shopify;
    if (isShopify) {
      // 全屏 窗口通信
      if (window.opener) {
        window.addEventListener('message', this.handleDataFromMainWin); // 接收主窗口数据
      } else {
        window.addEventListener('message', this.handleDataFromChildWin); // 接收子窗口数据
      }
    }
    // cw埋点状态
    const storeStatus = store.getState().public.status;
    // 访问方式
    this.props.setShowTopMenu(Boolean(!isShopify));
    const _store = this.props.public;
    const _query = Boolean(this.props.history.location?.query === 'guide');
    this.setState({
      isDouble: _store.uid % 2 === 0,
      isNeedTrack: !Boolean(storeStatus), // 是否需要上传cio
    }, () => {
      if (storeStatus) {
        this.cioDataSet();
        this.cwreportDataSet();
      }
      // 调用redux派遣 根据状态只调用一次
      if (!_store.status || _query) {
        // 如果全局公共数据状态为0则请求
        this.getPublicAppData();
        this.connectHomeSSE();
      } else {
        // 判断是否进入引导
        let guideData = store.getState().public.publicInit?.guide_steps;
        let guideStateItem = Boolean(guideData && guideData.length > 0) ? guideData.find(i => i.step_key === "select_model") : false;
        let isGoGuide = Boolean(guideStateItem) ? guideStateItem?.is_completed === 0 : false;
        let switchData = store.getState().public.publicInit?.head_data?.switch_data;
        let isShowAiGuide = typeof switchData === 'boolean' ? true : !Boolean(switchData?.create_guide_finished);
        let isGetAiGuide = isShowAiGuide && Boolean(guideData && guideData.length > 0);
        if (isGoGuide) {
          this.setState({
            isShowShopifyNavMenu: false
          }, () => {
            utils.routeJump(this, "/guide");
          })
        } else {
          this.setState({
            isCanSetModal: true,
            guideStateData: store.getState().public.publicInit?.guide_steps || [],
            isShowAiGuide: isGetAiGuide,
          })
        }

        this.props.setAppPublicInit();
        // 获取顶部数据
        this.getHeaderInfo(_store.publicInit);
        // 获取活动数据
        // this.getIndexInfoData(_store.publicInit);
        // 如果是首页请求更新一次
        if (['/', '/dashboard'].includes(window.location.pathname)) {
          this.setState({
            isResetData: true,
            quotaAll: _store.publicInit.meal_data,
            switchData: store.getState().public.publicInit.head_data?.switch_data,
          }, () => {
            // 第二次先缓存再更新
            this.getPublicAppData();
            this.connectHomeSSE();
            this.changeAppHomeStatus();
          })
        }
      }

      this.getRecommandAppList(_store.AllAdverData); // 获取广告
      // const url = this.props.history.location.pathname;
      // if (url && (url.includes('/dashboard') || url === '/')) {
      //   this.getRecommandAppList(_store.AllAdverData); // 获取广告
      // } else {
      //   this.setState({
      //     adverloading: false,
      //   })
      // }


      // 获取改版活动数据
      // if(Object.keys(_store.ActMealData).length > 0) {
      //   this.getDiscountActData(_store.ActMealData)
      // } else {
      //   this.getDiscountActData(); 
      // }

      // // 获取改版活动数据
      this.getDiscountActData();

      // 切换默认在顶部开始预览
      window.scrollTo(0, 0);

      // 默认展开导航栏
      if (window.isSetNav === '') {
        window.isExpandedNav = true;
        window.isHoverChange = false;
      }

      window.FrameBlock = this; // 缓存事件
      window.addEventListener('resize', this.reSize, true);
      this.setState({
        isExpandedNav: window.isExpandedNav,
        isHoverChange: window.isHoverChange,
      }, () => {
        this.resetContentSite();
        // if (!isShopify) {
        //   this.optNavMenuIcon();
        // }
      })
    })

    store.subscribe(() => {
      // 判断数据
      const _winData = store.getState().public?.windowData;
      if (_winData) {
        this.setWindowSendData(_winData);
      }
    })

    // 判断是否价格页
    let c_url = window.location.pathname;
    if (c_url.includes('/plan')) {
      this.changePopoverCss(true);
    } else {
      this.changePopoverCss(false);
    }

  }

  // Sidekick 埋点
  sidekickTrackDataSet = async (data) => {
    let params = {
      event_id: uuidv4(),
      source_event_id: data.source_event_id,
      landing_page: data.landing_page,
      open_success: true,
    }
    await reqTrackDeepLinkOpen(params);
  }

  // 监听 操作聊天icon
  toggleChatIcon = () => {
    const portalRoot = document.querySelector('#PolarisPortalsContainer');
    if (!portalRoot) {
      setTimeout(() => {
        this.toggleChatIcon();
      }, 1000);
      return;
    }

    let modalExist = false;
    let pending = false;

    const checkModal = () => {
      let windowWidth = window.innerWidth; // 屏幕宽度
      if (pending || windowWidth > 768) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        const modal = portalRoot.querySelector('.Polaris-Modal-Dialog__Container');
        const exists = !!modal;
        if (exists && !modalExist) {
          modalExist = true;
          onShow();
        } else if (!exists && modalExist) {
          modalExist = false;
          onHide();
        }
      });
    };

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length || m.removedNodes.length) {
          checkModal();
          break; // 检测到一个变化就足够，不用继续遍历
        }
      }
    });

    observer.observe(portalRoot, {
      childList: true,
      subtree: true
    });

    function onShow() {
      // 隐藏聊天icon
      let initChatIcon = document.querySelector('.intercom-lightweight-app');
      let curChatIcon = document.querySelector('.intercom-app');
      initChatIcon && (initChatIcon.style.display = 'none');
      curChatIcon && (curChatIcon.style.display = 'none');
    }

    function onHide() {
      // 显示聊天icon
      let initChatIcon = document.querySelector('.intercom-lightweight-app');
      let curChatIcon = document.querySelector('.intercom-app');
      initChatIcon && (initChatIcon.style.display = 'block');
      curChatIcon && (curChatIcon.style.display = 'block');
    }

  }

  // 获取优惠卷
  getCouponOffer = async () => {
    const res = await reqGetCouponOffer({ coupon_code: "NewUser50" });
    if (res.ack === 1) {
      this.getUserPricingPlanList();
    }
  }

  // 获取价格套餐版本
  getUserPricingPlanList = async () => {
    let res = await reqGetNewUserPricingPlanList();
    this.props.getPageDataRedux(res, 'pricingPlan');
    if (res.ack === 1) {
      this.handleToggleEOfferModal(true);
    } else {
      this.toggleToast(res.msg, true);
    }
  }

  // 设置弹窗样式
  changePopoverCss = (isSet = true) => {
    const STYLE_ID = 'popover-tooltip-style';
    let styleEl = document.getElementById(STYLE_ID); // 识别唯一id
    if (isSet) {
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = STYLE_ID;
        styleEl.textContent = `
        .Polaris-Tooltip-TooltipOverlay__Content {
          background-color: #1a1826;
          color: #fdfdff;
        }
        .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail,
        .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail path {
          fill: #1a1826;
        }
        .Polaris-Tooltip-TooltipOverlay--wide {
          max-width: 350px;
        }
      `;
        document.head.appendChild(styleEl);
      }
    } else {
      if (styleEl) {
        styleEl.remove();
      }
    }
  }

  // cw埋点
  cioDataSet = () => {
    try {
      let url = window.location.pathname || '';
      // cio埋点
      if (window.shopify && window.cio?.initialized) {
        window.cio?.page({
          pathname: url.includes('/dashboard') ? '/' : url, // 当前页面路径
          triggerIO: true // 是否立即上报
        })

        // 判断首页和套餐页执行事件上传
        if (url.includes('/dashboard') || url.includes('/plan')) {
          window.cio?.trigger({
            event: url.includes('/dashboard') ? 'view_home_page' : 'view_plan_page', // 事件名称
          })
        }
      }
    } catch { }
  }

  // posthog埋点
  cwreportDataSet = () => {
    try {
      // posthog埋点
      if (window.shopify && cwreport) {
        let url = window.location.pathname || '';
        // 判断首页和套餐页执行事件上传
        if (url === '/dashboard') {
          transportReport('view_home_page')
        }
        if (url === '/plan') {
          transportReport('view_plan_page')
        }
      }
    } catch { }
  }

  // 设置数据
  setWindowSendData = (data) => {
    const _t = data;
    if (_t.mode === "edit_page_modal") {
      // 根据不同modal组件传参定义事件
      switch (_t.objs) {
        // case "amp":
        // break;
        case "onpageAi":
          if (_t._query) {
            this.setState({
              embedOnpageAIData: _t._query,
            })
          }
          break;
        case "onpageBlog":
          if (_t._query) {
            this.setState({
              embedOnpageBlogData: _t._query,
            })
          }
          break;
        default:
          break;
      }
    }
  }

  // 设置状态
  setCongratsState = debounce(() => {
    let urlArr = [
      "/speedOpt/PageSpeed",
      "/speedOpt/PageSpeed/settings",
      "/speedOpt/site-speedup",
      "/on-page-seo/list",
      "/on-page-seo/detail",
      "/on-page-seo/bulk-edit/manual-bulk-edit",
    ]
    let url = window.location.pathname;
    let { isShowGetQuota, isGetGuideCoupon, isGetGuideEffect, congraState } = this.state;
    let isOperaState = false;
    try {
      isOperaState = Boolean(sessionStorage.getItem("isOperaCongrats"));
    } catch (e) { }
    this.setState({
      congraState: congraState === -1 ? false : (!isOperaState && isShowGetQuota && urlArr.includes(url) && isGetGuideCoupon && !isGetGuideEffect),
    })
  }, 500)

  resetContentSite = () => {
    if (store.getState().public.isShowTopMenu) {
      const SEOContent = document.getElementById('SEOpage_content');
      const TabsPublic = document.getElementById('TabsPublic');
      if (Boolean(window.isExpandedNav) && Boolean(!window.isHoverChange) && window.innerWidth > 768) {
        Boolean(SEOContent) && (SEOContent.style.paddingLeft = '15rem');
        Boolean(TabsPublic) && (TabsPublic.style.paddingLeft = '15rem');
      } else {
        Boolean(SEOContent) && (SEOContent.style.paddingLeft = '3.8rem');
        Boolean(TabsPublic) && (TabsPublic.style.paddingLeft = '3.8rem');
      }
    }
  }

  // 子窗口传参
  handleDataFromChildWin = (ev) => {
    // 安全校验：只接收同源窗口的消息，防止第三方页面伪造 postMessage
    if (ev.origin !== window.location.origin) return;
    const _that = ev.data;
    if (_that.mode === "UpgradeOpener") {
      this.handleModalCustomizeState(false, _that.url, _that.objs, _that._state, _that._query);
    } else if (_that.mode === "UpdatePublish") {
      this.setState({
        onpagePubilsh: Boolean(_that.data?.publish),
        onpagePubilshLoading: Boolean(_that.data?.loading),
      })
    } else { }
  }

  // 获取超管广告数据
  getRecommandAppList = async (data) => {
    let params = {
      platform: 'seoant'
    }
    let res = {};
    if (data?.ack === 1) {
      res = data;
      // this.getRecommandAppList({});
    } else {
      res = await reqGetAppAds(params);
    }
    if (res.ack === 1) {
      this.props.setAdminAdverData(res);
      // 获取各页面广告数据
      let _t = res.data.data;
      let seocheckAdver = _t.find(item => item.type === 'seo_checker_top');
      let imageOptAdver = _t.find(item => item.type === 'Image_opt_center');
      let contentAuditAdver = _t.find(item => item.type === 'content_audit_top');
      let auditDetailAdver = _t.find(item => item.type === 'audti_detail_top');
      let metaTagAdver = _t.find(item => item.type === 'meta_tag_center');
      let structureAdver = _t.find(item => item.type === 'structure_data_top');
      let structureReviewApps = _t.filter(item => item.type === 'structure_product_review');
      let structureSupportedReviewApps = _t.filter(item => item.type === 'structure_supported_review');
      this.setState({
        adverInfo: res,
        adverloading: false,
        seocheckAdver,
        imageOptAdver,
        contentAuditAdver,
        auditDetailAdver,
        metaTagAdver,
        structureAdver,
        structureReviewApps,
        structureSupportedReviewApps,
      })
    }
  }

  // 优化导航图表
  optNavMenuIcon = () => {
    // 部分icon高亮特殊处理
    const fillUrls = [];
    const fillMoreUrls = ["/on-page-seo/list", '/keywordRearch', '/keywordRearch/keywords-research', '/speedOpt/seo-ant-amp'];
    const strokeUrls = ['/website-check', '/settings'];
    const strokeMoreUrls = ['/speedOpt', '/technicalSEO', '/backlinks', '/speedOpt/site-speedup', '/on-page-seo/bulk-edit/manual-bulk-edit', '/technicalSEO', '/speedOpt', '/plan'];
    let jumpIconUrl = document.querySelectorAll('.Polaris-Navigation__Item.Polaris-Navigation__Item--selected.Polaris-Navigation--subNavigationActive');
    let jumpMoreIconUrl = document.querySelectorAll('.Polaris-Navigation__Item.Polaris-Navigation--subNavigationActive');
    // 一级导航
    jumpIconUrl.forEach(objs => {
      if (fillUrls.indexOf(objs.getAttribute('href')) > -1) {
        let pathObjs = objs.firstChild.firstChild.children[0].children;
        for (let i = 0; i < pathObjs.length; i++) {
          pathObjs[i].style.fill = 'none';
        }
      }
      if (strokeUrls.indexOf(objs.getAttribute('href')) > -1) {
        let pathObjs = objs.firstChild.firstChild.children[0].children;
        for (let i = 0; i < pathObjs.length; i++) {
          pathObjs[i].style.stroke = 'none';
        }
      }
    })
    // 有下级导航
    jumpMoreIconUrl.forEach(objs => {
      if (fillMoreUrls.indexOf(objs.getAttribute('href')) > -1) {
        if (Boolean(objs.firstChild.firstChild.children[0])) {
          let pathObjs = objs.firstChild.firstChild.children[0].children;
          for (let i = 0; i < pathObjs.length; i++) {
            pathObjs[i].style.fill = 'none';
          }
        }
      }
      if (strokeMoreUrls.indexOf(objs.getAttribute('href')) > -1) {
        if (Boolean(objs.firstChild.firstChild.children[0])) {
          let pathObjs = objs.firstChild.firstChild.children[0].children;
          for (let i = 0; i < pathObjs.length; i++) {
            pathObjs[i].style.stroke = 'none';
          }
        }
      }
    })

    // 默认展开二级导航栏处理
    // const urlPath = window.location.pathname;
    // const objUrls = ['/speedOpt/site-speedup', '/speedOpt/instant-page', '/speedOpt/PageSpeed', '/admin/PageSpeed/setting'];
    // let fatherIcon = document.querySelectorAll('.Polaris-Navigation__ItemInnerWrapper .Polaris-Navigation--subNavigationActive');
    // fatherIcon.forEach(tag => {
    //   if(tag.getAttribute('href').indexOf(objUrls[0]) > -1 && indexTag === 0 && tag.getAttribute('aria-expanded')) {
    //     if(objUrls.includes(urlPath)) {
    //       if(Boolean(tag.firstChild.firstChild.children[1])) {
    //         tag.firstChild.firstChild.children[1].style.fill = '#008060';
    //         let pathObjs = tag.firstChild.firstChild.children[1].children;
    //         for(let i = 0; i < pathObjs.length; i++) {
    //           pathObjs[i].style.fill = '#008060';
    //           pathObjs[i].style.stroke = 'none';
    //         }
    //       }
    //       indexTag += 1;
    //     } else {
    //       if(Boolean(tag.firstChild.firstChild.children[1])) {
    //         tag.firstChild.firstChild.children[1].style.fill = '#5c5f62';
    //         let pathObjs = tag.firstChild.firstChild.children[1].children;
    //         for(let i = 0; i < pathObjs.length; i++) {
    //           pathObjs[i].style.fill = '#5c5f62';
    //           pathObjs[i].style.stroke = 'none';
    //         }
    //         document.querySelectorAll('.Polaris-Navigation__ItemInnerWrapper--selected')[0].style.backgroundColor = 'unset';
    //         document.querySelectorAll('.Polaris-Navigation__Item--selected')[0].style.color = 'unset';
    //       }
    //     }
    //   }
    // })
  }

  // 获取活动改版弹窗数据
  getDiscountActData = async () => {
    store.subscribe(() => {
      const res = this.props.public.ActMealData;
      if (Boolean(this.props.public.Language) && res && Object.keys(res).length > 0) {
        if (res.plan_type === 0) {
          let _data = this.props.public.publicInit;
          // 没有活动
          this.setState({
            ActRversion: {},
            isHasActivityMeal: false,
            quotaAll: _data.meal_data,
            switchData: _data.head_data?.switch_data,
          })
        } else {
          this.setState({
            ActRversion: res,
            isHasActivityMeal: true,
          })
          if (Boolean(res.expired_time)) {
            this.countdown(res.expired_time)
          }
        }
        this.setState({
          isActLoading: false
        })
      }
    })
  }

  // 获取公共数据
  getPublicAppData = async () => {
    const params = new URLSearchParams(window.location.search);
    if (getCookie("seoant_irclickid") && getCookie("seoant_irclickid").length > 1) {
      params.set('irclickid', getCookie("seoant_irclickid"));
    }
    const response = await reqGetHomeInit(params);
    if (response.code === 301) {
      // 否则跳转安装
      window.location.href = response.jump_url;
    } else {
      if (response.code === 200) {
        const isShopify = window.shopify;
        const _t = response.data;

        // 判断是否跳转
        let switchData = _t.head_data?.switch_data;
        let lang = _t.shop_data?.language || 'en';
        // this.handleLanguageSet(lang);

        // 获取顶部数据
        this.getHeaderInfo(_t);
        // 获取活动数据
        // this.getIndexInfoData(_t);

        // const _store = store.getState().public;
        // if (!window.opener && !Boolean(_store.shopifyLangState)) {
        // 获取授权数据 翻译shopify语言
        // this.setShopifyLanguage();
        // }

        // 判断是否进行引导
        let guideData = _t?.guide_steps;
        let guideStateItem = Boolean(guideData && guideData.length > 0) ? guideData.find(i => i.step_key === "select_model") : false;
        let isGoGuide = Boolean(guideStateItem) ? guideStateItem?.is_completed === 0 : false;
        if (isGoGuide) {
          utils.routeJump(this, "/guide");
          this.setState({
            pageName: "NewUserGuide",
            isShowShopifyNavMenu: false
          }, () => {
            this.props.getPublicDataRedux(response);
          })
        } else {
          this.setState({
            isCanSetModal: true
          }, () => {
            this.props.getPublicDataRedux(response);
          })
        }

        // 判断是否进行引导更新
        let hasAiGuide = Boolean(guideData && guideData.length > 0);
        let isShowAiGuide = typeof switchData === 'boolean' ? true : !Boolean(switchData?.create_guide_finished);

        // 条件: 大于测试id 且 id为单数 且 内嵌模式
        let uid = _t.shop_data.id;
        // const isShowInfo = ((Number(uid) <= 37055) || (Number(uid) > 37055 && (Number(uid) % 2) !== 0) || !isShopify);
        const isShowInfo = Boolean(!isShopify);
        this.props.setShowTopMenu(isShowInfo);
        store.dispatch(setAiGuideList(_t.guide_steps || []));
        this.setState({
          uid: uid,
          isDouble: uid % 2 === 0,
          isShowInfo: isShowInfo,
          quotaAll: _t.meal_data,
          switchData,
          shopInfo: _t.shop_data,
          ppid: _t.shop_data.pricing_plan_id,

          modalEmail: _t.shop_data.email,
          modalDefaultEmail: _t.shop_data.email,
          modalName: window.shopOwner,
          isComboUser: _t.head_data?.is_combo_plan,
          guideStateData: _t.guide_steps || [],
          language: lang,
          isShowAiGuide: isShowAiGuide && hasAiGuide,
          domain: _t.shop_data.domain,
        }, () => {
          // 设置内嵌模式样式
          if (isShopify) {
            Boolean(document.getElementById('SEOpage_content')) && (document.getElementById('SEOpage_content').style.paddingLeft = '');
            Boolean(document.getElementById('TabsPublic')) && (document.getElementById('TabsPublic').style.paddingLeft = '');
          } else {
            Boolean(document.getElementById('SEOpage_content')) && (document.getElementById('SEOpage_content').style.paddingLeft = '15rem');
            Boolean(document.getElementById('TabsPublic')) && (document.getElementById('TabsPublic').style.paddingLeft = '15rem');
          }

          // 埋点
          if (this.state.isNeedTrack) {
            this.cioDataSet();
            this.cwreportDataSet();
          }

          // 判断是否本地更新语言
          // if (!window.shopify) {
          //   this.handleLanguageSet(_t.shop_data?.language || 'en');
          // }

          /** 
           * 判断是否弹窗 50% OFF
           * 1. 注册24小时后仍未付费
           * 2. 未响应折扣
           * 3. 折扣力度判断
           * */
          if (_t.shop_data.level === 1 && window.location.pathname !== '/guide') {
            this.verifyShowCouponModal(_t);
          }
        })
      }
    }
  }

  // 解析首页流式数据
  parseHomeSSEData = (dataStr) => {
    if (dataStr === '[DONE]') return null;

    try {
      return JSON.parse(dataStr);
    } catch (error) {
      const timeoutMatch = dataStr.match(/^\["error":"([\s\S]*?)","elapsed":(\d+)\]$/);

      if (timeoutMatch) {
        return {
          error: timeoutMatch[1],
          elapsed: Number(timeoutMatch[2]),
          isTimeout: timeoutMatch[1].includes('timeout'),
        };
      }

      console.error('homeStream data parse error:', error, dataStr);
      return null;
    }
  }

  // 解析首页流式消息
  parseHomeSSEMessage = (msg) => {
    return msg.split('\n').reduce((result, line) => {
      if (line.startsWith('event:')) {
        return {
          ...result,
          event: line.replace(/^event:\s*/, ''),
        };
      }

      if (line.startsWith('data:')) {
        return {
          ...result,
          data: [...result.data, line.replace(/^data:\s*/, '')],
        };
      }

      return result;
    }, { event: '', data: [] });
  }

  // 处理首页流式消息
  handleHomeSSEMessage = (msg) => {
    const { event, data } = this.parseHomeSSEMessage(msg.trim());

    if (!data.length) return;

    const dataStr = data.join('\n');
    const obj = this.parseHomeSSEData(dataStr);

    if (!obj) return;

    if (obj.error) {
      console.warn('homeStream block error:', obj.error, obj);
      return;
    }

    // 非错误处理
    const _state = JSON.stringify(obj);
    if (!_state.includes('error') && !_state.includes('timeout')) {
      switch (event) {
        case 'seo_data':
        case 'other_options':
          let data = cloneDeep(obj);
          if (event === 'other_options') {
            data.state = 1;
            this.setState({
              isNewUserIncentives: obj?.is_new_user_incentives,
              trial_days: obj?.trial_days,
            })
          }
          this.props.setHomeStreamRedux({
            type: event,
            data,
          }); // 设置更新缓存
          break;
        case 'campaign_data':
          this.setState({
            isFirstCloseConponModal: Boolean(obj) && obj.coupon_list.coupon_pop ? false : true,
            showCouponData: Boolean(obj) && obj.coupon_list !== undefined ? obj.coupon_list : false,
            showBlackFridayModal: Boolean(obj) && obj.campaign_modal.middle_status ? Number(obj.campaign_modal.middle_status) : -1,
            showBlackFridayBanner: Boolean(obj) && obj.campaign_modal.top_status ? Number(obj.campaign_modal.top_status) : -1,
          }, () => {
            this.getIndexInfoData(obj);
          })
          break;
        case 'chatwill':
          store.dispatch(setChatwillInstalled(obj?.installed));
          break;
        // case 'opt_overview':
        //   break;
        // case 'ads_data':
        //   break;
        default:
          break;
      }
    }
  }

  // 获取首页流式数据
  connectHomeSSE = async () => {
    try {
      let shopify = window.shopify;
      const token = shopify ? await shopify.idToken() : utils.getStore('authToken');
      const type = shopify ? `ShopifyBridge` : `ShopifyAdmin`;
      const res = await fetch(`${API_DOMAIN}/api/v2/homeStream`, {
        method: 'GET',
        headers: {
          Accept: 'text/event-stream',
          Authorization: `${type} ${token}`,
        },
      });

      if (!res.ok || !res.body) {
        console.warn('homeStream request error:', res.status, res.statusText);
        return;
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const messages = buffer.split('\n\n');

        // 最后一个可能不完整，留着下次拼接
        buffer = messages.pop();
        messages.forEach(this.handleHomeSSEMessage);
      }

      if (buffer) {
        this.handleHomeSSEMessage(buffer);
      }
    } catch (error) {
      console.error('homeStream request failed:', error);
    }
  }

  // 获取引导步骤
  getGuideSteps = async () => {
    let res = await reqGetGuideSteps();
    if (res.ack === 1) {
      store.dispatch(setAiGuideList(res.data));
      this.setState({
        guideStateData: res.data,
      })
    }
  }

  // 判断是否展示优惠券弹窗
  verifyShowCouponModal = (_t) => {
    let currentTime = Math.floor(Date.now() / 1000);
    let switchData = _t.head_data?.switch_data;
    let _pricingPlan = store.getState().page.pageInit?.pricingPlan;
    if (_pricingPlan) {
      let res = _pricingPlan.data;
      let planInfo = {
        pro: this.computeBestDiscount(res.meal_list.month[0]),
        pre: this.computeBestDiscount(res.meal_list.month[1]),
      }
      let isSmallDiscount = !Boolean(planInfo.pro?.rate) || !Boolean(planInfo.pre?.rate) || (Boolean(planInfo.pro?.rate) && planInfo.pro?.rate < 1 && planInfo.pro?.rate > 0.5) || (Boolean(planInfo.pre?.rate) && planInfo.pre?.rate < 1 && planInfo.pre?.rate > 0.5); // 判断折扣是否满足
      if (isSmallDiscount && !Boolean(_t.head_data?.is_pay) && ((currentTime - _t.shop_data.created_at) > 86400) && !Boolean(switchData?.exclusive_offer_modal) && Boolean(switchData?.get_new_user_coupon_50) && !Boolean(switchData?.get_new_user_coupon_50?.st === 1)) {
        this.getCouponOffer();
      }
    } else {
      setTimeout(() => {
        this.verifyShowCouponModal(_t);
      }, 1000);
    }
  }

  // 计算每个版本的最优力度 - 优惠券优先
  computeBestDiscount = (data) => {
    let obj_data = {};
    // 有试用天数的优惠券优先
    if (Object.keys(data.coupon_info).length > 0 && data.coupon_info.trial_days > 0) {
      // 优惠券
      obj_data = {
        rate: Number(data.coupon_info.rate),
      };
    } else if (Object.keys(data.coupon_info).length > 0 || Boolean(data?.discount_rate)) {
      // 无试用 需计算活动和优惠券的力度
      let c_price = Number(data.coupon_info?.discount_price) || -1;
      let d_price = Number(data?.discount_price) || -1;
      let rate = "";
      if (c_price !== -1 && d_price !== -1) {
        rate = c_price > d_price ? data.discount_rate : data.coupon_info.rate;
      } else if (c_price !== -1 && d_price === -1) {
        rate = data.coupon_info.rate;
      } else if (c_price === -1 && d_price !== -1) {
        rate = data.discount_rate;
      } else {
        rate = "";
      }
      obj_data = {
        rate: Number(rate),
      }
    } else {
      // 无优惠
      obj_data = {
        rate: "",
      }
    }

    return obj_data;
  }

  // 接收 主窗口
  handleDataFromMainWin = (ev) => {
    // 安全校验：只接收同源窗口的消息，防止第三方页面伪造 postMessage
    if (ev.origin !== window.location.origin) return;
    const _t = ev.data;
    if (_t.mode === "edit_page_modal") {
      store.dispatch(setWindowSendData(_t));
      // if (!_t.shopifyLang) {
      //   // 更新shopify语言
      //   this.setShopifyLanguage();
      // } else {
      //   // 更新本地语言
      //   this.handleLanguageSet(_t.language || 'en');
      // }
      this.handleLanguageSet(_t.language || 'en');

      // 根据不同modal组件传参定义事件
      switch (_t.objs) {
        // case "amp":
        // break;
        case "onpageAi":
          if (_t._query) {
            this.setState({
              embedOnpageAIData: _t._query,
            })
          }
          break;
        case "onpageBlog":
          if (_t._query) {
            this.setState({
              embedOnpageBlogData: _t._query,
            })
          }
          break;
        default:
          break;
      }
    }
  }

  // 设置shopify语言
  setShopifyLanguage = () => {
    const params = new URLSearchParams(window.location.search);
    const shopifyLang = params.get("locale");
    if (shopifyLang) {
      // 获取授权数据 翻译shopify语言
      const ShopifyLangList = {
        "cs": "cs",
        "da": "da",
        "de": "ge",
        "en": "en",
        "es": "sp",
        "fr": "fr",
        "it": "it",
        "in": "in",
        "nl": "dut",
        "nb": "nb",
        "pl": "pl",
        "pt-BR": "pt_BR",
        "pt-PT": "pt",
        "fi": "fi",
        "sv": "sv",
        "tr": "tr",
        "th": "th",
        "ja": "ja",
        "zh-CN": "zh",
        "zh-TW": "zh_hant",
        "ko": "ko",
      }
      const lang = ShopifyLangList[shopifyLang] ? ShopifyLangList[shopifyLang] : 'en';
      store.dispatch(setShopifyLang(lang));
      store.dispatch(changeLanguageInfo(lang));
    } else {
      this.handleLanguageSet('en');
    }
  }

  // 设置更新语言
  handleLanguageSet = (lang = 'en') => {
    store.dispatch(setLangState(false)); // 重置语言状态
    store.dispatch(changeLanguageInfo(lang));
  }

  // 判断接口状态
  changeAppHomeStatus = () => {
    let res = this.props.public;
    if (Number(res.error.code) === 300) {
      this.toggleToast(res.error.msg, true);
    } else {
      if (!res.status) {
        setTimeout(() => {
          this.changeAppHomeStatus();
        }, 1000)
      }
    }
  }

  // 获取活动数据
  getIndexInfoData = (data) => {
    let res = data.activity_list;
    if (res && Boolean(res?.id)) {
      // 有活动
      this.setState({
        activityMes: res,
        isHasActivity: true,
        actId: res.id,
        actName: res.name,
      }, () => {
        window.actId = res.id;
        window.actName = res.name;
      })
    }
  }

  componentWillUnmount() {
    // 清空提示弹窗
    const isShopify = window.shopify;
    isShopify?.toast?.hide?.();
    // 清除
    window.removeEventListener('message', this.handleDataFromMainWin);
    window.removeEventListener('message', this.handleDataFromChildWin);
    window.removeEventListener('resize', this.reSize);
    // indexTag = 0;
    this.setState = () => false;
  }

  reSize = () => {
    this.setState({
      wInnerWidth: window.innerWidth,
    }, () => {
      // 设置缓存宽度
      this.props.saveWindowWidth(window.innerWidth);
    })
    // 解决屏幕改变出现2个下拉框
    let basicHiddenTimer = setInterval(() => {
      let basicHidden = document.querySelector('.basicHidden')
      if (basicHidden) {
        basicHidden.setAttribute('style', 'display:none')
        clearInterval(basicHiddenTimer)
      }
    }, 1);
    let AdvancedHiddenTimer = setInterval(() => {
      let AdvancedHidden = document.querySelector('.AdvancedHidden')
      if (AdvancedHidden) {
        AdvancedHidden.setAttribute('style', 'display:none')
        clearInterval(AdvancedHiddenTimer)
      }
    }, 1);

    this.resetContentSite();
  }

  //给子组件清除倒计时方法
  clearExpirationString = (val) => {
    if (val === true) {
      this.setState({
        couponExpirationString: " "
      })
      cacheTimer.forEach(item => {
        clearInterval(item);
      })
      // clearInterval(cacheTimer);
    }
  }

  //用户是否评价
  getHeaderInfo = (data) => {
    let _store = data;
    let lang = _store?.shop_data?.language || 'en';
    this.handleLanguageSet(lang);
    //把service相关服务存储window里
    this.setState({
      showReview: _store.head_data.is_review,
      countNews: _store.head_data.notice_num,
      //等级
      level: _store.shop_data.level,
      shopify_level: Boolean(_store.shop_data) && _store.shop_data.plan_display_name,
      modalEmail: Boolean(_store.shop_data) && _store.shop_data.email,
      modalDefaultEmail: Boolean(_store.shop_data) && _store.shop_data.email,
      domain: _store.shop_data.domain,
      language: lang,
    });
    window.email = Boolean(_store.shop_data) && _store.shop_data.email;

    this.setState({
      modalName: window.shopOwner
    });
  }

  // 升级弹窗
  upgradeModal = ($plan, type = 'Backlink', position = '', isCredits = false) => {
    store.dispatch(setUpgradePosition(position));
    this.setState({
      upgradeModalShow: $plan === 1 ? 'pro' : 'pre',
      upgradeModalType: type,
      upgradeModalPosition: position,
      creditsShow: isCredits
    })
  };

  closeModal = ($type) => {
    if ($type === 1) {
      this.setState({
        proPlanshow: false
      });
    }

    if ($type === 2) {
      this.setState({
        premiumPlanShow: false
      });
    }
  };

  //选择类型
  selectClenCode = (type) => {
    this.setState({
      has_selected: true
    });
    if (type === '404') {
      this.setState({
        selected_404: 'selected',
        selected_json: '',
        selected_all: '',
        showCleanPrompt: this.state.app_status === 0 || this.state.app_status === 3 ? false : true,
        showCleanPromptText: t("This operation will delete the SEOMasterBrokenLinkRedirect.liquid file, which cannot automatically monitor new 404 links, are you sure you want to delete it?")
      });
    } else if (type === 'json') {
      this.setState({
        selected_404: '',
        selected_json: 'selected',
        selected_all: '',
        showCleanPrompt: this.state.app_status === 0 || this.state.app_status === 2 ? false : true,
        showCleanPromptText: t("This operation will delete the file inserted to introduce theme: {% render 'structuredDataV2' %}{% render 'SEO-Master' %} and the inserted file: SEOMaster.liquid, your JSON-LD will be affected, it may affect the inclusion, are you sure you want to delete it?")
      });
    } else if (type === 'all') {
      this.setState({
        selected_404: '',
        selected_json: '',
        selected_all: 'selected',
        showCleanPrompt: this.state.app_status === 0 ? false : true,
        showCleanPromptText: t("This operation will delete all the files, your JSON-LD, broken link will be affected (except for the changes that have been synced to Shopify online and will not be deleted), are you sure you want to delete them?")
      });
    }
  };

  //点击打开弹窗
  openReviewModal = () => {
    this.setState({
      openReview: true
    })
  }

  //组件传来的关闭新手折扣弹窗的方法
  changeOpenStatus = (val) => {
    if (val === false) {
      this.setState({
        firstReqClose: true
      })
    }
    this.setState({
      openStatus: val
    })
  }

  // 传递modal状态
  closeBigSaleModalStatus = (data, types) => {
    if (types === 'modal') {
      // 广告
      this.props.changeActivityShowStatus('0', '1');
      this.setState({
        showBlackFridayBanner: 0,
        showBlackFridayModal: 1,
      })
    } else {
      // 版图
      this.props.changeActivityShowStatus('1', '1');
      this.setState({
        showBlackFridayBanner: 1,
        showBlackFridayModal: 1,
      })
    }
  }

  // 跳转活动详情页
  jumpAppActivityDetail = () => {
    // 事件埋点
    let params = { from: 1, action: 1, event: this.state.actName };
    reqAddActionEventLog(params);
    utils.routeJump(this, '/admin/app-activity/index', { actId: this.state.actId, actName: this.state.actName }, { email_jump: 'app_jump' })
  }

  // 设置支付弹窗提示
  changePayTipStatus = (val) => {
    this.props.setPayTipStatusData(val);
  }


  // 时分秒倒计时
  countdown = async (end_time) => {
    var cacheTimer = setInterval(() => {
      let date1 = new Date(); //开始时间
      let date2 = end_time * 1000; //开始时间
      let date3 = date2 - date1 //时间差的毫秒数
      if (date3 < 1000) {
        clearInterval(cacheTimer);
        this.setState({
          isHasActivityMeal: false,
          openActMealModal: false
        })
      } else {
        //计算出小时数
        let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
        let hours = Math.floor(date3 / (3600 * 1000))

        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000))
        //计算相差秒数
        let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)

        let exp_time = "";

        if (hours < 10) {
          exp_time += "0" + hours + ":"
        } else {
          exp_time += hours + ":"
        }
        if (minutes < 10) {
          exp_time += "0" + minutes + ":"
        } else {
          exp_time += minutes + ":"
        }
        if (seconds < 10) {
          exp_time += "0" + seconds
        } else if (seconds === 60) {
          exp_time += "00"
        } else {
          exp_time += seconds
        }
        this.setState({ act_expired_time: exp_time })
      }
    }, 1000)
    // 毫秒倒计时
    setTimeout(() => {
      setInterval(() => {
        let date1 = new Date(); //开始时间
        let date2 = end_time * 1000; //开始时间
        let date3 = date2 - date1 //时间差的毫秒数
        if (date3 < 0) {
          this.setState({ act_expired_mills_time: "00" })
        } else {
          //计算相差毫秒数
          let milli = date3 % (100)

          let exp_time = "";

          if (milli < 10) {
            exp_time += "0" + milli
          } else {
            exp_time += milli
          }
          this.setState({ act_expired_mills_time: exp_time })
        }
      }, 80)
    }, 1000)
  }

  // 打开弹窗
  openActMealModalAction = () => {
    this.setState({
      openActMealModal: true
    })
  }

  // 关闭弹窗
  changeActMealModal = () => {
    this.setState({
      openActMealModal: false,
    }, () => {
      if (window.giftEvent) {
        window.giftEvent.changeActMealModal();
      }
    })
  }

  // 打开任务
  openTaskBlock = () => {
    this.setState({
      isShowTask: true,
    })
  }

  // 关闭任务
  closeTaskBlock = () => {
    this.setState({
      isShowTask: false,
    })
  }

  // 设置外层图片额度
  setImageQuota = () => {
    this.setState({
      isAddImageQuota: true
    })
  }

  // 关闭价格套餐
  changeUpgradeState = () => {
    this.setState({
      upgradeModalShow: false,
    })
  }

  // 关闭试用弹窗
  handleCloseTrialModal = () => {
    this.setState({
      showTrialModalState: false,
    })
  }

  // 关闭更多使用弹窗
  handleCloseGetMoreUsageModal = () => {
    this.setState({
      showGetMoreUsageModal: false,
    })
  }

  // 关闭独家优惠弹窗
  handleToggleEOfferModal = (_state) => {
    if (_state) {
      this.requestStateSet('exclusive_offer_modal', 1);
    }
    this.setState({
      showExclusiveOfferModal: _state,
    })
  }

  // 清除当前店铺的支付成功提示，身份由服务端鉴权确定。
  delApiCache = async () => {
    const res = await reqDelCache();
    if (res.ack === 1) {
      // 更新公共数据
      this.props.setPayTipState(0);
    }
  }

  // 打开内嵌全屏模态框
  showEditPageModal = (url, modal, _state = null, _query = null) => {
    setTimeout(() => {
      this.handleModalCustomizeState(true, url, modal, _state, _query); // 打开弹窗
    }, 50)
  }

  // 弹窗状态
  handleModalCustomizeState = async (state = true, url = null, modal = "", _state = null, _query = null) => {
    const shopify = window.shopify;
    if (shopify && modal) {
      if (state) {
        const _store = this.props.public;
        window.history.replaceState(null, "", url);      // 只更新路由不跳转
        this.setState({
          isOpenModal: true,
          isFromPage: _query?.jumptype || 'onpage',
        }, async () => {
          await shopify.modal.show(modal);
          // 对象属性定义
          const objs = modal === "AMP_Customize_Modal" ? "amp" :
            modal === "OnpageAI_Modal" ? "onpageAi" : ""
          // modal === "OnpageBlog_Modal" ? "onpageBlog" : "";
          this.sendBadgeDataToModal({ mode: "edit_page_modal", objs, shopifyLang: Boolean(_store.shopifyLangState), language: _store.Language, _state, _query }, modal);
        })
      } else {
        // 更新路由
        const routeArr = ['/settings', '/plan', '/on-page-seo/detail', '/content-seo/ai-blog-generator/generate']; // 需要携带参数
        if (routeArr.filter(r => url.indexOf(r) > -1).length > 0) {
          utils.routeJump(this, url, _state, _query);
        } else {
          utils.routeJump(this, url);
        }
        this.setState({
          isOpenModal: false,
        }, async () => {
          await shopify.modal.hide(modal);
        })
      }
    } else {
      this.toggleToast(t("Try again later"), true);
    }
  }

  // 操作数据
  handleModalCustomizeData = (type = "save", objs = "") => {
    const shopify = window.shopify;
    if (shopify) {
      this.sendBadgeDataToModal({ mode: type }, objs);
    }
  }

  // 传递给窗口 通信
  sendBadgeDataToModal = (data, objs) => {
    const objsIframe = document.getElementById(objs);
    if (objsIframe && objsIframe.contentWindow) {
      objsIframe.contentWindow.postMessage(data, window.location.origin);
    } else {
      // 保证通信完成
      setTimeout(() => {
        this.sendBadgeDataToModal(data, objs);
      }, 100)
    }
  }

  // 关闭提示弹层
  updCongraState = (state) => {
    this.setState({
      congraState: -1,
      isCloseCongra: true,
    }, () => {
      // 更新新手引导状态
      let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
      if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
        data.get_guide_coupon = { "at": Math.floor(new Date().getTime() / 1000), "st": state };
        store.dispatch(setSaveSwitchData(data));
      }

      try {
        sessionStorage.setItem("isOperaCongrats", "close");
      } catch (e) { }
    })
  }

  // 任务操作
  toggleTaskType = (type, _state) => {
    this.setState({
      [type]: Boolean(_state)
    })
  }

  //弹窗组件关闭 子组件传值到父组件
  ChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openReview: val
    })
  }

  //弹窗组件提交评价成功 子组件传值到父组件 如果有值重新请求接口
  ChildrenReRequest = (val) => {
    //这个val就是子组件传来的
    // if (val) {
    //     this.getHeaderInfo();
    // }
    this.setState({
      showReview: false
    })
  }

  // 打开试用弹窗
  showTrialModal = (type = 1) => {
    this.setState({
      showTrialModalState: true,
      stageType: type
    })
  }

  // 打开cw组合套餐提示弹窗
  handleOpenCwComboModal = (type) => {
    this.setState({
      isShowCwComboModal: true,
      [type]: false,
    })
  }

  // 跳转cw集合页
  goSolutionExpert = () => {
    utils.routeJump(this, "/settings", null, { selected: "Solutionexpert", tabkey: 5 });
  }

  // cw埋点 套餐
  cioPlanDataSet = (type, version, quota, price) => {
    try {
      if (window.shopify && window.cio?.initialized) {
        window.cio?.trigger({
          event: 'change_plan',
          payload: {
            plan_type: type,        // 'monthly' | 'annually'
            plan_version: version,  // pro | pre
            // plan_quota: quota,
            plan_monthly_price: price
          }
        })
      }

      // posthog埋点
      this.cwreportPlanDataSet(type, version, quota, price);
    } catch { }
  }

  // cw埋点 套餐
  cwreportPlanDataSet = (type, version, quota, price) => {
    try {
      if (window.shopify && cwreport) {
        transportReport('change_plan', {
          plan_type: type, // 'monthly' | 'annually'
          plan_version: version,  // pro | pre
          // plan_quota: quota,
          plan_monthly_price: `${price}`
        })
      }
    } catch { }
  }

  // 打开更多使用弹窗
  handleShowGetMoreUsageModal = (type, quota = 0) => {
    this.setState({
      showGetMoreUsageModal: true,
      limitType: type,
      remainQuota: quota
    })
  }

  // 发送请求
  requestStateSet = async (type, st = 0) => {
    const params = {
      name: `${type}`,
      st,
      exp: 0,
      type: `param`
    }
    const res = await reqSaveSwitchState(params);
    if (res.ack === 1) {
      let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data);
      if (typeof data === 'boolean') {
        data = [];
      }
      data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": st, "exp": 0 };
      store.dispatch(setSaveSwitchData(data));
    } else {
      // this.toggleToast(t("Try again later"), true);
    }
  }

  // 打开升级上限弹窗（超额已达上限 -> OverageFeeModal）
  openUpdateLimit = () => {
    this.setState({
      overageFeeState: true
    })
  }

  // 埋点
  addClickNums = async (id) => {
    const params = {
      ad_id: id,
      click_num: 1,
    }
    await reqAddAdsClickNum(params);
  }

  // 传递参数到主窗口
  sendDataToMain = (info = "", _type = 'url') => {
    const wpener = window.opener;
    if (wpener) {
      // 判断全屏对象
      const pathUrl = window.location.pathname;
      const fullPage = {
        "OnpageAI_Modal": "/on-page-seo/detail",
        "AMP_Customize_Modal": "/speedOpt/seo-ant-amp/custome",
      }
      let modalObj = Object.keys(fullPage).find(key => pathUrl.indexOf(fullPage[key]) > -1);
      if (_type === 'url') {
        let { url, _state, _query } = info;
        wpener.postMessage({ mode: "UpgradeOpener", url, objs: modalObj, _state, _query }, window.location.origin);    // 传递数据到主窗口
      } else {
        info.objs = modalObj;
        wpener.postMessage({ page: "Edit", mode: info }, window.location.origin);    // 传递数据到主窗口
      }
    }
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror, showState = true) => {
    // 判断提示方式
    const shopify = window.shopify;
    if (showToastText) {
      if (shopify) {
        shopify.toast.hide();
        let settings = {
          duration: 3000,
          isError: Boolean(showToastIserror)
        }
        if (showState) {
          shopify.toast.show(showToastText, settings);
        } else {
          shopify.toast.hide();
        }
      } else {
        this.setState({
          showToast: false
        }, () => {
          this.setState({
            showToast: showState,
            showToastText: showToastText || '',
            showToastIserror: showToastIserror || ''
          });
        });
      }
    }
  };

  // 获取套餐来源
  handleGetPlanSource = (type, data) => {
    const { source_type, planRes, planInfo, selData } = data;  // planRes: 价格方案数据
    const sourceAll = computePlanSource(type, source_type, planRes, planInfo, selData);
    return sourceAll;
  }

  // 打开超额弹窗（供各页面复用）
  // { type: 'points' | 'image', points: number, onSuccess: fn } —— onSuccess 用于触发页刷新/重试
  openOverageModal = ({ type = 'points', points = 0, onSuccess } = {}) => {
    this.overageOnSuccess = onSuccess;
    this.setState({
      overageState: true,
      overageType: type,
      overagePoints: points,
    })
  }

  // 关闭超额弹窗
  handleToggleOverageModal = (state) => {
    this.setState({
      overageState: state
    })
  }

  // 开启超额成功后的回调（转交触发页）
  handleOverageSuccess = (res) => {
    if (this.overageOnSuccess) {
      this.overageOnSuccess(res);
    }
  }

  // 关闭超额已达上限弹窗
  handleToggleOverageFeeModal = (state) => {
    this.setState({
      overageFeeState: state
    })
  }

  //点击联系客服
  handleContactService = () => {
    try {
      showNewMessage();
    } catch (e) {
      this.toggleToast(t("Try again later"), true);
    }
  }

  // 面包屑点击
  handleBreadcrumbClick = (crumb) => {
    // 判断保存栏是否显示状态
    const isShopify = window.shopify;
    if (isShopify && window.savebarState) {
      isShopify.saveBar.leaveConfirmation();
    } else {
      this.props.history.push(crumb.parentPath);
    }
  }

  // posthog埋点 ======================================================= start
  // 推荐app点击
  cwreportRecommendAppClick = (position, id, name) => {
    if (window.shopify && cwreport) {
      transportReport('recommend_app_click', {
        position,
        recommend_app_id: `${id}`,
        recommend_app_name: name,
      });
    }
  }
  // 引导入口曝光 || 点击进入结账
  cwreportCustomBehavior = (type = 'guide_entry_exposure', data) => {
    if (window.shopify && cwreport) {
      try {
        // feature_limit | usage_limit | free_trial | promotion
        let reportProps = this.handleGetPlanSource(type, data);
        transportReport(type, reportProps);
      } catch (error) {
        console.log('error:', error);
      }
    }
  }
  // posthog埋点 ======================================================= end

  render() {
    const {
      state: {
        pageName,
        isHideNewbieTipModal,
        adverInfo,
        adverloading,
        isShowTask,
        // isNewUserIncentives,
        switchData,
        quotaAll,
        isAddImageQuota,
        upgradeModalShow,
        upgradeModalType,
        level,
        // isActLoading,
        trial_days,
        // creditsShow,
        isShowShopifyNavMenu,
        isOpenModal,
        isCanSetModal,
        onpagePubilsh,
        onpagePubilshLoading,
        embedOnpageAIData,
        congraState,
        // embedOnpageBlogData,
        // isFromPage,
        isShowFeedback,
        isShowSharePlat,
        openReview,
        reviewContent,
        modalEmail,
        modalName,
        modalDefaultEmail,
        showTrialModalState,
        stageType,
        limitType,
        showGetMoreUsageModal,
        showExclusiveOfferModal,
        isComboUser,
        isShowCwComboModal,
        language,
        remainQuota,
        allowPathShow,
        isShowAiGuide,
        guideStateData,
        seocheckAdver,
        imageOptAdver,
        contentAuditAdver,
        auditDetailAdver,
        metaTagAdver,
        structureAdver,
        domain,
        structureReviewApps,
        structureSupportedReviewApps,
        overageState,
        overageType,
        overagePoints,
        overageFeeState,
      },
    } = this;

    // 内嵌模式 shopify
    const isShopify = window.shopify;

    // 提示
    const toastMarkup = this.state.showToast ? <ToastFunc content={t(this.state.showToastText)} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;

    // 页面组件
    let pageContent = "";
    // 缓存接口数据
    let _store = this.props.public;
    if (pageName === "ReportData") {
      // 报告
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ReportData upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "dashboard") {
      //首页
      pageContent = <DashboardClass cwreportRecommendAppClick={this.cwreportRecommendAppClick} requestStateSet={this.requestStateSet} toggleTaskType={this.toggleTaskType} isAddImageQuota={isAddImageQuota} adverloading={adverloading} adverInfo={adverInfo} changePayTipStatus={this.changePayTipStatus} isResetData={this.state.isResetData} dashboardData={_store} callbackGetHome={this.getPublicAppData} setHomeStreamRedux={this.props.setHomeStreamRedux} toggleToast={this.toggleToast} />
    } else if (pageName === "website-check") {
      //SEO Checker 检测页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <WebsiteCheckClass cwreportRecommendAppClick={this.cwreportRecommendAppClick} adverData={seocheckAdver} addClickNums={this.addClickNums} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "SiteSpeedup") {
      // 速度优化
      pageContent = <SiteSpeedup handleGetPlanSource={this.handleGetPlanSource} cwreportCustomBehavior={this.cwreportCustomBehavior} changePopoverCss={this.changePopoverCss} upgradeModalShow={upgradeModalShow} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
    } else if (pageName === "html-sitemap") {
      //HTML Sitemap 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <HtmlSitemap toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "Broken-link") {
      // BrokenLink 页面
      pageContent = <BrokenLinkPage upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
    } else if (pageName === "structured-data") {
      // Json LD 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <StructuredData requestStateSet={this.requestStateSet} adverData={structureAdver} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} getPageDataRedux={this.props.getPageDataRedux} addClickNums={this.addClickNums} level={level} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "organization") {
      // Organization 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <OrganizationSet level={level} domain={domain} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "product-schema") {
      // Product Schema 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ProductSchema level={level} structureReviewApps={structureReviewApps} structureSupportedReviewApps={structureSupportedReviewApps} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "Bulk-edit") {
      //批量操作页面V2
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ManualBulkEdit level={level} adverData={metaTagAdver} addClickNums={this.addClickNums} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === 'BacklinkAudit') {
      //外链审查页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <BacklinkAudit upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === 'exchange-backlink') {
      //外链互换页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ExchangeBacklink handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "InstantIndex") {
      // Instant Index
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <InstantIndex upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "ImageAltText") {
      // 图片alt
      pageContent = <ImageAltText toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptAltDetail") {
      // 图片alt 详情
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ImageOptAltDetail toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "ImageOptimization") {
      //图片压缩页面
      pageContent = <ImageOptimization cwreportRecommendAppClick={this.cwreportRecommendAppClick} adverData={imageOptAdver} addClickNums={this.addClickNums} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptimizationDetail") {
      //图片压缩详情
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ImageOptimizationDetail toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "ImageOptimizationSettings") {
      //图片压缩设置页
      pageContent = <ImageOptimizationSettings toggleToast={this.toggleToast} />
    } else if (pageName === "on-page-seo") {
      //On page 操作页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <OnPageSEOIndexClass cwreportRecommendAppClick={this.cwreportRecommendAppClick} adverData={contentAuditAdver} addClickNums={this.addClickNums} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
      // } else if (pageName === "on-page-seo-detail") {
      //   //On page 操作页面
      //   pageContent = <Suspense fallback={<SkeltonLoading />}>
      //     <OnPageSEODetail adverData={auditDetailAdver} addClickNums={this.addClickNums} embedOnpageAIData={embedOnpageAIData} openUpdateLimit={this.openUpdateLimit} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      //   </Suspense>
    } else if (pageName === "ContentAuditDetail") {
      //On page 操作页面
      pageContent = <ContentAuditDetail requestStateSet={this.requestStateSet} level={level} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
    } else if (pageName === "site-verifications") {
      // 网站验证
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <SiteVerification toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "crawling-indexing") {
      // 爬取索引
      pageContent = <CrawlingIndexing level={level} domain={domain} getPageDataRedux={this.props.getPageDataRedux} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
    } else if (pageName === "llms-txt") {
      // llms.txt
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <LlmsTxt level={level} domain={domain} upgradeModal={this.upgradeModal} getPageDataRedux={this.props.getPageDataRedux} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "seo-metadata") {
      // SEOMetadata
      pageContent = <SEOMetadata toggleToast={this.toggleToast} />
    } else if (pageName === "Keyword-content-planner") {
      // 关键词规划
      pageContent = <KeywordContentPlanner level={level} callbackGetHome={this.getPublicAppData} requestStateSet={this.requestStateSet} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
    } else if (pageName === "content-planner-detail") {
      // 关键词规划详情
      pageContent = <ContentPlannerDetail level={level} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} requestStateSet={this.requestStateSet} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} showEditPageModal={this.showEditPageModal} />
    } else if (pageName === "Ai-blog-generator") {
      // 博客生成器
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <AiBlogGenerator requestStateSet={this.requestStateSet} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} level={level} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "Ai-blog-generator-progree") {
      // 博客生成器进度页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <GenerateProgress requestStateSet={this.requestStateSet} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} handleShowGetMoreUsageModal={this.handleShowGetMoreUsageModal} showEditPageModal={this.showEditPageModal} level={level} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "Keywords-data") {
      // 关键词
      pageContent = <KeywordsData level={level} openUpdateLimit={this.openUpdateLimit} openOverageModal={this.openOverageModal} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} showEditPageModal={this.showEditPageModal} />
    } else if (pageName === "Competitor-keywords-detail") {
      //竞品关键词分析页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <CompetitorKeywordsDetail level={level} upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsSearch") {
      // 关键词搜索
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsSearch upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsGap") {
      // 关键词对比
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsGap upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsMonitor") {
      // 关键词监听
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsMonitor upgradeModal={this.upgradeModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "google-search-console") {
      //google流量分析页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <GoogleSearchConsole level={level} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "seo-ant-amp") {
      //AMP 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ServiceAMPClass level={level} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "seo-ant-amp-custome") {
      //AMP 设置页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ServiceAMPCustome level={level} isCanSetModal={isCanSetModal} upgradeModal={this.upgradeModal} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === 'canny') {
      //问答页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <Canny toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "integration") {
      //推荐应用页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <Integration cwreportRecommendAppClick={this.cwreportRecommendAppClick} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "pricing") {
      //价格页面
      pageContent = <Pricing handleGetPlanSource={this.handleGetPlanSource} cwreportCustomBehavior={this.cwreportCustomBehavior} language={language} callbackGetHome={this.getPublicAppData} handleToggleEOfferModal={this.handleToggleEOfferModal} toggleToast={this.toggleToast} />
    } else if (pageName === "oldversion-pricing") {
      //旧版价格页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <OldPricing language={language} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "Settings") {
      // 设置页面
      pageContent = <Settings cwreportRecommendAppClick={this.cwreportRecommendAppClick} language={language} toggleToast={this.toggleToast} />
    } else if (pageName === "NewUserGuide") {
      // 新手引导
      pageContent = <NewUserGuide
        language={language}
        isComboUser={isComboUser}
        getPageDataRedux={this.props.getPageDataRedux}
        toggleToast={this.toggleToast}
        showTrialModal={this.showTrialModal}
        cioPlanDataSet={this.cioPlanDataSet}
        handleOpenCwComboModal={this.handleOpenCwComboModal}
        cwreportCustomBehavior={this.cwreportCustomBehavior}
        handleGetPlanSource={this.handleGetPlanSource}
      />
    } else {
      pageContent = null;
    }

    // const newUserDiscountIcon = (this.state.couponExpirationString !== " " && this.state.close === undefined &&
    //   (window.location.pathname !== '/dashboard' && window.location.pathname !== '/plan' && !window.location.pathname.includes('/admin/seo-expert-services'))) ? <div className='emphasize' onClick={() => this.setState({ openStatus: true })}>
    //   <span className="time">{this.state.couponExpirationString}</span>
    //   <div className="in">
    //     <Icon source={BehaviorMajor} />
    //   </div>
    //   <svg t="1648014053003" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1775" width="4rem" height="4rem"><path d="M98.56 256.512m102.4 0l622.08 0q102.4 0 102.4 102.4l0 524.288q0 102.4-102.4 102.4l-622.08 0q-102.4 0-102.4-102.4l0-524.288q0-102.4 102.4-102.4Z" fill="#F6DAF7" p-id="1776"></path><path d="M98.56 280.832m102.4 0l622.08 0q102.4 0 102.4 102.4l0 427.264q0 102.4-102.4 102.4l-622.08 0q-102.4 0-102.4-102.4l0-427.264q0-102.4 102.4-102.4Z" fill="#F9E8F9" p-id="1777"></path><path d="M415.669592 175.023881m48.112263-17.511431l315.135317-114.699876q48.112262-17.511431 65.623694 30.600831l64.704738 177.774809q17.511431 48.112262-30.600831 65.623694l-315.135317 114.699875q-48.112262 17.511431-65.623693-30.600831l-64.704739-177.774809q-17.511431-48.112262 30.600831-65.623693Z" fill="#BE92F1" p-id="1778"></path><path d="M97.092709 298.04071m17.503034-48.115318l64.67371-177.786099q17.503034-48.115318 65.618352-30.612284l315.155331 114.644872q48.115318 17.503034 30.612284 65.618352l-64.67371 177.786099q-17.503034 48.115318-65.618352 30.612284l-315.155331-114.644872q-48.115318-17.503034-30.612284-65.618352Z" fill="#BE92F1" p-id="1779"></path><path d="M633.6 281.6h-243.2V163.072a76.8 76.8 0 0 1 76.8-76.8h89.6a76.8 76.8 0 0 1 76.8 76.8zM414.72 377.856h194.56v534.784h-194.56z" fill="#CBB0F7" p-id="1780"></path><path d="M414.72 912.64h194.56v72.96h-194.56z" fill="#BE92F1" p-id="1781"></path><path d="M98.56 450.816h826.88v48.64H98.56z" fill="#F6DAF7" p-id="1782"></path><path d="M414.72 450.816h194.56v48.64h-194.56z" fill="#BE92F1" p-id="1783"></path><path d="M25.6 232.192m51.2 0l870.4 0q51.2 0 51.2 51.2l0 116.224q0 51.2-51.2 51.2l-870.4 0q-51.2 0-51.2-51.2l0-116.224q0-51.2 51.2-51.2Z" fill="#F0A0F2" p-id="1784"></path><path d="M174.08 300.032c-34.816-2.048-42.24-25.6-21.248-29.44 37.888-7.168 217.6 0 238.848 8.192 4.608 2.048-11.008 7.936-41.472 10.496-68.608 6.4-154.624 12.288-176.128 10.752z" fill="#FFFFFF" p-id="1785"></path><path d="M105.984 283.904m-16.384 0a16.384 16.384 0 1 0 32.768 0 16.384 16.384 0 1 0-32.768 0Z" fill="#FFFFFF" p-id="1786"></path></svg>
    // </div> : null
    const couponModal =
      <EventInformation
        showType={this.state.showType}
        couponData={this.state.showCouponData}
        openStatus={this.state.openStatus}
        isFirstCloseConponModal={this.state.isFirstCloseConponModal}
        firstReqClose={this.state.firstReqClose}
        noviceGuideIsDone={this.state.noviceGuideIsDone}
        level={this.state.level}
        showBlackFridayBanner={this.state.showBlackFridayBanner}
        showBlackFridayModal={this.state.showBlackFridayModal}
        activityMes={this.state.activityMes}
        isHasActivity={this.state.isHasActivity}
        actId={this.state.actId}
        actName={this.state.actName}
        ActRversion={this.state.ActRversion}
        isHasActivityMeal={this.state.isHasActivityMeal}
        act_expired_time={this.state.act_expired_time}
        act_expired_mills_time={this.state.act_expired_mills_time}
        openActMealModal={this.state.openActMealModal}
        isHideNewbieTipModal={isHideNewbieTipModal}
        changeOpenStatus={this.changeOpenStatus}
        closeBigSaleModalStatus={this.closeBigSaleModalStatus}
        changeActMealModal={this.changeActMealModal}
        trial_days={trial_days}
        cwreportCustomBehavior={this.cwreportCustomBehavior}
      />

    // 任务奖励
    const taskBlock = <TaskReward
      quotaAll={quotaAll}
      switchData={switchData}
      isShowTask={isShowTask}
      isShowFeedback={isShowFeedback}
      isShowSharePlat={isShowSharePlat}
      closeTaskBlock={this.closeTaskBlock}
      setImageQuota={this.setImageQuota}
      toggleTaskType={this.toggleTaskType}
    />

    //newReview弹窗
    const newReview = <Suspense fallback={<div>Loading...</div>}>
      <NewReviewModal
        open={openReview}
        changeData={this.ChildrenChange}
        content={reviewContent}
        reRequest={this.ChildrenReRequest}
        modalEmail={modalEmail}
        modalName={modalName}
        modalDefaultEmail={modalDefaultEmail}
      />
    </Suspense>

    // cw组合套餐提示弹窗
    const CWComboModal = <Modal
      open={isShowCwComboModal}
      title={t("Plan reminder")}
      primaryAction={{
        content: t("Go to view"),
        onAction: this.goSolutionExpert,
      }}
      secondaryActions={[
        {
          content: t("Close"),
          onAction: () => {
            this.setState({ isShowCwComboModal: false })
          }
        }
      ]}
      onClose={() => {
        this.setState({ isShowCwComboModal: false })
      }}
    >
      <Modal.Section>
        <p>{t("You are currently using CWILL's package, please update your plan on the package page")}</p>
      </Modal.Section>
    </Modal>

    // 临时悬浮邮箱
    // const temporaryEmail = false && <a href='mailto:help@seoant.com' target='_blank' rel='noopener noreferrer' className='temporary-email' style={{ left: `${isShopify ? '20px' : '-260px'}` }}>
    //   <span className='temporary-email-content'>
    //     <span>
    //       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M14.25 4.5C15.7688 4.5 17 5.73122 17 7.25V12.75C17 14.2688 15.7688 15.5 14.25 15.5H5.75C4.23122 15.5 3 14.2688 3 12.75V7.25C3 5.73122 4.23122 4.5 5.75 4.5H14.25ZM5.75 6C5.05964 6 4.5 6.55964 4.5 7.25V12.75C4.5 13.4404 5.05964 14 5.75 14H14.25C14.9404 14 15.5 13.4404 15.5 12.75V7.25C15.5 6.55964 14.9404 6 14.25 6H5.75ZM13.4326 7.57031C13.8079 7.39517 14.2545 7.55738 14.4297 7.93262C14.6048 8.30792 14.4426 8.75447 14.0674 8.92969L10.5283 10.5811C10.1934 10.7372 9.80659 10.7372 9.47168 10.5811L5.93262 8.92969C5.55738 8.75447 5.39517 8.30792 5.57031 7.93262C5.74553 7.55738 6.19208 7.39517 6.56738 7.57031L10 9.17188L13.4326 7.57031Z" fill="white" />
    //       </svg>
    //     </span>
    //     <span>Email us</span>
    //   </span>
    // </a>

    // 创作悬浮弹层
    const createFloatingModule = <CreateFloatingModule
      isShowAiGuide={isShowAiGuide}
      allowPathShow={allowPathShow}
      guideStateData={JSON.stringify(guideStateData)}
      requestStateSet={this.requestStateSet}
      toggleToast={this.toggleToast}
    />

    return (
      Boolean(_store.status && _store.Language) ? <div id="SEOpage_content" style={{ paddingLeft: `${isShopify ? '' : window.isExpandedNav ? '15rem' : '3.8rem'}`, maxWidth: '100%' }} className={`${window.innerWidth <= 768 ? 'mobileNavPage' : ''}`}>
        {/* shopify - 内嵌模块 */}
        {
          (isShopify && !window.opener) ? <div className="ShopifyEmbedBlock">
            {/* 标题栏 */}
            {
              pageName !== "dashboard" && (() => {
                const crumb = PAGE_BREADCRUMB[pageName];
                // 命中面包屑配置：第三层只显示子级标题，并渲染可点击返回的父级 breadcrumb 按钮
                // 未命中：保持原样展示完整标题
                const title = crumb ? t(crumb.selfKey) : t(PAGE_NAME_PATH[pageName]);
                return (
                  <TitleBar title={title}>
                    {crumb && (
                      <button variant="breadcrumb" onClick={this.handleBreadcrumbClick}>
                        {t(PAGE_NAME_PATH[crumb.parentName])}
                      </button>
                    )}
                  </TitleBar>
                );
              })()
            }
            {/* 侧边导航栏 */}
            {
              isShowShopifyNavMenu && <NavMenuList />
            }
            {/* 模态框 */}
            <ModalAMPCustomize handleModalCustomizeState={this.handleModalCustomizeState} handleModalCustomizeData={this.handleModalCustomizeData} />
            <ModalOnpageAI
              onpagePubilsh={onpagePubilsh}
              onpagePubilshLoading={onpagePubilshLoading}
              handleModalCustomizeState={this.handleModalCustomizeState}
              handleModalCustomizeData={this.handleModalCustomizeData}
            />
          </div> : null
        }
        {/* shopify - 内嵌模块 */}

        {
          isOpenModal ? null : <>
            {couponModal}
            {pageContent}
            {/* {temporaryEmail} */}
            {taskBlock}
            {toastMarkup}
            {/* {newUserDiscountIcon} */}
            {/* {expertSubplanModal} */}
            {newReview}
            {createFloatingModule}
            <CWTracksProvider />
            {/* 完成新手引导弹窗 */}
            <CongratsModal
              congraState={congraState}
              toggleToast={this.toggleToast}
              updCongraState={this.updCongraState}
            />
            {/* 新版价格套餐弹窗 */}
            <NewDiscountUpgradeModal
              openState={upgradeModalShow}
              upgradeModalType={upgradeModalType}
              trial_days={trial_days}
              changeUpgradeState={this.changeUpgradeState}
              isComboUser={isComboUser}
              handleOpenCwComboModal={this.handleOpenCwComboModal}
              getPageDataRedux={this.props.getPageDataRedux}
              cioPlanDataSet={this.cioPlanDataSet}
              toggleToast={this.toggleToast}
              sendDataToMain={this.sendDataToMain}
              cwreportCustomBehavior={this.cwreportCustomBehavior}
              handleGetPlanSource={this.handleGetPlanSource}
            />
            {/* 试用折扣弹窗 */}
            <UserTrialDicountModal
              openState={showTrialModalState}
              operaType={stageType}
              language={language}
              isModal={true}
              handleCloseTrialModal={this.handleCloseTrialModal}
              isComboUser={isComboUser}
              handleOpenCwComboModal={this.handleOpenCwComboModal}
              getPageDataRedux={this.props.getPageDataRedux}
              cioPlanDataSet={this.cioPlanDataSet}
              toggleToast={this.toggleToast}
              sendDataToMain={this.sendDataToMain}
              cwreportCustomBehavior={this.cwreportCustomBehavior}
              handleGetPlanSource={this.handleGetPlanSource}
            />
            {/* 更多额度弹窗 */}
            <GetMoreUsageModal
              operaType={limitType}
              openState={showGetMoreUsageModal}
              isComboUser={isComboUser}
              remainQuota={remainQuota}
              handleOpenCwComboModal={this.handleOpenCwComboModal}
              getPageDataRedux={this.props.getPageDataRedux}
              handleCloseGetMoreUsageModal={this.handleCloseGetMoreUsageModal}
              cioPlanDataSet={this.cioPlanDataSet}
              toggleToast={this.toggleToast}
              cwreportCustomBehavior={this.cwreportCustomBehavior}
              handleGetPlanSource={this.handleGetPlanSource}
            />
            {/* 独家优惠弹窗 */}
            <ExclusiveOfferModal
              openState={showExclusiveOfferModal}
              isComboUser={isComboUser}
              handleOpenCwComboModal={this.handleOpenCwComboModal}
              getPageDataRedux={this.props.getPageDataRedux}
              handleToggleEOfferModal={this.handleToggleEOfferModal}
              cioPlanDataSet={this.cioPlanDataSet}
              toggleToast={this.toggleToast}
              cwreportCustomBehavior={this.cwreportCustomBehavior}
              handleGetPlanSource={this.handleGetPlanSource}
            />
            {CWComboModal}

            {/* 超额弹窗 */}
            <OverageModal
              open={overageState}
              onClose={() => this.handleToggleOverageModal(false)}
              type={overageType}
              points={overagePoints}
              isTrial={trial_days > 0}
              language={language}
              onSuccess={this.handleOverageSuccess}
              onWaitForReset={() => this.handleToggleOverageModal(false)}
              onContact={this.handleContactService}
              toggleToast={this.toggleToast}
            />

            {/* 超额已达上限弹窗 */}
            <OverageFeeModal
              open={overageFeeState}
              onClose={() => this.handleToggleOverageFeeModal(false)}
              language={language}
              onWaitForReset={() => this.handleToggleOverageFeeModal(false)}
              onContact={this.handleContactService}
            />
          </>
        }
      </div> : <SkeltonSpinnerLoading />
    );
  }
}


function getCookie(cookieName) {
  //获取所有的cookie "psw=1234we; rememberme=true; user=Annie"
  var totalCookie = document.cookie;
  //获取参数所在的位置
  var cookieStartAt = totalCookie.indexOf(cookieName + "=");
  //判断参数是否存在 不存在直接返回
  if (cookieStartAt === -1) {
    return;
  }
  //获取参数值的开始位置
  var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1;
  //以;来获取参数值的结束位置
  var valueEndAt = totalCookie.indexOf(";", cookieStartAt);
  //如果没有;则是最后一位
  if (valueEndAt === -1) {
    valueEndAt = totalCookie.length;
  }
  //截取参数值的字符串
  var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt));
  return cookieValue;
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 调用派遣 异步请求公共数据
  getPublicDataRedux(res) {
    // dispatch(fetchPublicData());
    dispatch(setPublicData(res));
  },

  // 修改活动banner/轮播图状态
  changeActivityShowStatus(banner, modal) {
    dispatch(changeActShowStatus([banner, modal]));
  },

  // 设置首页数据初始状态
  setAppPublicInit() {
    dispatch(setAppPublicInit());
  },

  // 设置宽度数据缓存
  saveWindowWidth(val) {
    dispatch(setWindowWidth(val));
  },

  // 设置滚动高度
  saveWindoScrollTop(height) {
    dispatch(setWindowScrollY(height))
  },

  // 设置支付弹窗提示状态
  setPayTipStatusData(val) {
    dispatch(setPayTipStatus(val))
  },

  // 设置改版活动数据
  setActMealData(data) {
    dispatch(setActMealResData(data))
  },

  // 设置顶部导航栏状态
  setShowTopMenu(data) {
    dispatch(setTopMenuState(data))
  },

  // 设置广告数据
  setAdminAdverData(data) {
    dispatch(setAllAdverData(data));
  },

  // 是否设置了滚动条
  setScrollHidden(val) {
    dispatch(setScrollHiddenState(val));
  },

  // 设置支付回调提示状态
  setPayTipState(data) {
    dispatch(savePayTip(data));
  },

  // 判断是否页面第一次loading
  getPageDataRedux(data, type) {
    dispatch(setPageData([type, data]));
  },

  // 设置首页流式数据
  setHomeStreamRedux(type, val) {
    dispatch(setHomeStreamData(type, val));
  },

})

FrameClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(FrameClass);

export default withRouter(FrameClass);